import React from 'react';
import { observable } from "mobx";
import AgendamentoDashboardService from "../../../../services/AgendamentoDashboardService";
import moment from "moment";
import { buscaSemResultado } from '../../../../utils/mensagens';

import lscache from "lscache";

export default class AgendamentoDashboardStore {

    @observable AgendListaFaina;
    @observable qtdRegistros;
    @observable loading;
    @observable modalCancelar;
    @observable modalMensagem;
    @observable responseAcao;

    /** Paginação */
    @observable total;
    @observable hasNextPage;

    /** Filtro */
    @observable filtroSelecionado;

    /** Select */
    @observable operacoes;
    @observable pendenciasAgendamento;
    @observable status;
    @observable dataConsulta;

    @observable operacoesPreenchido;
    @observable tiposPreenchido;
    @observable statusPreenchido;
    @observable idSelecionado;
    @observable modalEditarAgendamento;
    @observable edicaoAgendamento;
    @observable mensagemEdicaoAgendamento;

    @observable tableMessage;
    @observable liberacaoLoading

    @observable listaAgendamentoResumo
    @observable atualizadoGeral

    @observable dashboardFiltroUserid;
    @observable dashboardFiltroTipoAgendamento;
    @observable dashboardFiltroData;
    @observable dataConsultaTitulo;
    @observable tipoFainaTitulo;

    @observable tiposAgendamento;
    @observable tiposAgenda;
    @observable tiposAgendaOpcoes;

    @observable opcaoFainaSelecionada;
    @observable horaDashboard;
    @observable listaHorasCapacidade;

    @observable modalAlerta;
    @observable mostrarModalOpcoes;
    @observable terminal;


    constructor(loginStore) {
        /** Select */
        this.operacoes = [];
        this.tiposAgendamentoTodos = [];
        this.pendenciasAgendamento = [];
        this.status = [];

        /** Paginação */
        this.total = null;
        this.hasNextPage = null;

        /** Filtros */
        this.filtrado = false;
        this.filtraDataCache = false;
        this.filtroSelecionado = [];
        this.tamanhoPagina = 100;
        this.filtrosObrigatorios = ["dataConsulta"];

        /** Serviços de Agendamento */
        this.agendamentoDashboardService = new AgendamentoDashboardService();

        this.tableMessage = "";

        /* Tela de Detalhes do Agendamento */
        this.listaAgendamentoResumo = {}

        /* Filtros Dashboard */
        this.dashboardFiltroUserid = lscache.get('MembershipuserId');
        this.dashboardFiltroTipoAgendamento = "";
        this.dashboardFiltroData = "";


        /* Informações do Dashboard */
        this.tiposAgendamento = [];
        this.tiposAgenda = [];
        this.tiposAgendaOpcoes = [];
        this.dataConsulta = moment().format("YYYY-MM-DD");
        this.dataConsultaTitulo = null;
        this.tipoFainaTitulo = null;
        this.horaLimite = null;
        this.horaDashboard = null;
        this.listaHorasCapacidade = [];
        this.atualizadoGeral = false;
        this.opcoesTiposAgendamento = {};
        this.opcaoFainaSelecionada = 0;
        this.mostrarModalOpcoes = false;
        this.dataAgenda = {};
        this.horaAgenda = {};
        this.modalAlerta = process.env.rig;

        this.listaDashboardDados = {
            ListaDashGeral: [],
            ListaDashInfo: [],
            ListaDashMember: [],
            ListaDashNoShow: []
        }

        this.listaDashboardGeral = {
            capacidade: [],
            atendidos: [],
            agendados: [],

        };
        this.listaDashboardMember = {
            agendados: [],
            gateExpresso: []
        };
        this.listaDashboardInfo = {};
        this.listaDashboardNoShow = {
            perdidos: []
        };

        this.terminal = process.env.rig ? process.env.rig : process.env.ssa;

        this.loginStore = loginStore;
    }

    can = (operacao = "C", tarefa = "AgendamentoContainer") => this.loginStore.can(tarefa, operacao)

    resetDashboardDados() {
        this.listaDashboardDados = {
            ListaDashGeral: [],
            ListaDashInfo: [],
            ListaDashMember: [],
            ListaDashNoShow: []
        }
    }


    setDashboardListaGeral = async () => {
        try {
            this.filtrado = false;

            this.listaDashboardGeral = {
                capacidade: [],
                atendidos: [],
                agendados: [],

            };
            if (this.listaDashboardDados.ListaDashGeral && this.listaDashboardDados.ListaDashGeral.length > 0) {
                await this.listaDashboardDados.ListaDashGeral.map((lista, index) => {
                    if (lista.Tipo.toUpperCase() === "CAPACIDADE") {
                        if (lista.Qtd)
                            this.listaDashboardGeral.capacidade.push(lista.Qtd)
                        else
                            this.listaDashboardGeral.capacidade.push(0);
                    }

                    if (lista.Tipo.toUpperCase() === "ATENDIDOS") {
                        if (lista.Qtd)
                            this.listaDashboardGeral.atendidos.push(lista.Qtd)
                        else
                            this.listaDashboardGeral.atendidos.push(0);
                    }

                    if (lista.Tipo.toUpperCase() === "AGENDADOS") {
                        if (lista.Qtd)
                            this.listaDashboardGeral.agendados.push(lista.Qtd)
                        else
                            this.listaDashboardGeral.agendados.push(0);
                    }
                });
            }
            else {
                for (let i = 0; i <= 23; i++) {
                    this.listaDashboardGeral.capacidade.push(0);
                    this.listaDashboardGeral.atendidos.push(0);
                    this.listaDashboardGeral.agendados.push(0);
                }
            }
            this.filtrado = true;
        }
        catch (erro) {
            console.log(erro);
        }
    }

    setDashboardListaMember = async () => {
        try {
            this.filtrado = false;

            this.listaDashboardMember = {
                agendados: [],
                gateExpresso: []
            };

            if (this.listaDashboardDados.ListaDashMember && this.listaDashboardDados.ListaDashMember.length > 0) {
                await this.listaDashboardDados.ListaDashMember.map((lista, index) => {
                    if (lista.Tipo.toUpperCase() === "AGENDADOS") {
                        this.listaDashboardMember.agendados.push(lista.Qtd);
                    }
                    if (lista.Tipo.toUpperCase() === "GATE EXPRESSO") {
                        this.listaDashboardMember.gateExpresso.push(lista.Qtd);
                    }
                });
            } else {
                this.listaDashboardMember.agendados.push(0);
                this.listaDashboardMember.gateExpresso.push(0);
            }

            this.filtrado = true;
        }
        catch (erro) {
            console.log(erro);
        }
    }

    setDashboardListaNoShow = async () => {
        try {
            this.filtrado = false;

            this.listaDashboardNoShow = {
                perdidos: []
            };

            if (this.listaDashboardDados.ListaDashNoShow && this.listaDashboardDados.ListaDashNoShow.length > 0) {
                await this.listaDashboardDados.ListaDashNoShow.map((lista, index) => {
                    this.listaDashboardNoShow.perdidos.push(lista.Qtd);
                });
            } else {
                this.listaDashboardNoShow.perdidos.push(0);
            }

            this.filtrado = true;
        }
        catch (erro) {
            console.log(erro);
        }
    }

    setDashboardListaInfo = async () => {
        try {
            this.filtrado = false;

            this.listaDashboardInfo = this.listaDashboardDados.ListaDashInfo;

            this.filtrado = true;
        }
        catch (erro) {
            console.log(erro);
        }
    }

    setModalOpcoes = (bool) => {
        this.mostrarModalOpcoes = bool;
    }

    carregarLista = async () => {
        try {
            this.loading = true;

            if (this.validacaoFiltros()) {

                await this.resetDashboardDados();

                this.dataConsultaTitulo = this.dashboardFiltroData;
                this.tipoFainaTitulo = this.tiposPreenchido.label;
                this.opcaoFainaSelecionada = 0;
                if (this.dashboardFiltroTipoAgendamento.value === 1) {
                    this.opcaoFainaSelecionada = this.dashboardFiltroTipoAgendamento.value;
                }
                if (this.dashboardFiltroTipoAgendamento.value === 46) {
                    this.opcaoFainaSelecionada = this.dashboardFiltroTipoAgendamento.value;
                }

                const response = await this.agendamentoDashboardService.listarDashboardDados(this.dashboardFiltroTipoAgendamento.value, this.dashboardFiltroData);

                if (response) {
                    this.listaDashboardDados = response.data;
                    this.total = this.listaDashboardDados.length;
                    if (this.listaDashboardDados.length === 0) {
                        this.tableMessage = buscaSemResultado
                    }
                    await this.carregarListaHoras(this.tiposAgenda);
                    await this.setDashboardListaGeral();
                    await this.setDashboardListaMember();
                    await this.setDashboardListaNoShow();
                    await this.setDashboardListaInfo();

                    this.atualizadoGeral = true;
                } else {
                    this.total = 0;
                    this.tableMessage = buscaSemResultado
                }
            }
            this.loading = false;
        }
        catch (error) {
            console.log(error);
        };
    }

    carregarTiposFainas() {
        this.tiposAgendamento = [];
        this.agendamentoDashboardService.listarFainas()
            .then(response => {
                this.tiposAgendamento = response.data;
            }).catch(error => {
                debugger
                console.log(error);
            })
    }

    carregarTiposAgendamentos = () => {
        this.tiposAgenda = [];
        this.agendamentoDashboardService.listarTipoAgendamento().then(response => {
            this.tiposAgenda = [];
            this.tiposAgendaOpcoes = [];
            if (response.data) response.data.map(e => {
                this.tiposAgenda.push({ value: e.Id, label: e.DscTipo, codIdentificador: e.CodIdentificador, codTipo: e.CodTipo, FainaId: e.FainaId });
                if ([1, 2, 9, 122, 123].includes(e.Id)) {
                    this.tiposAgendaOpcoes.push({ value: e.Id, label: e.DscTipo, codIdentificador: e.CodIdentificador, codTipo: e.CodTipo, FainaId: e.FainaId });
                }
            });

        }).catch(error => {
            console.log(error);
        })
    };

    getTipoAgendaIdFromFainaId = (listaTipoAgendamento, fainaId) => {
        let TipoAgendaId = {};
        listaTipoAgendamento.map(tipo => {
            if (tipo.FainaId === fainaId) {
                TipoAgendaId = {
                    codIdentificador: tipo.codIdentificador,
                    codTipo: tipo.codTipo,
                    label: tipo.label,
                    value: tipo.value
                }
            }
        });
        return TipoAgendaId;
    }

    getTipoAgendaIdFromOpcoes = (listaTipoAgendamento, agendaId) => {
        let TipoAgendaId = {};
        listaTipoAgendamento.map(tipo => {
            if (tipo.value === agendaId) {
                TipoAgendaId = {
                    codIdentificador: tipo.codIdentificador,
                    codTipo: tipo.codTipo,
                    label: tipo.label,
                    value: tipo.value
                }
            }
        });
        return TipoAgendaId;
    }

    carregarListaHoras = async () => {
        try {
            let listaHoras = [];
            this.listaHorasCapacidade = [];
            this.horaLimite = null;
            if (this.tiposPreenchido.value !== 0 && this.dashboardFiltroData) {
                let tipoAgendamento = this.getTipoAgendaIdFromFainaId(this.tiposAgenda, this.tiposPreenchido.value);
                if (tipoAgendamento) {
                    let response = await this.agendamentoDashboardService.listarHoras(tipoAgendamento.value, moment(this.dashboardFiltroData).format("DD-MM-YYYY"));
                    if (response.data) {
                        response.data.map(e => {
                            if (_.get(e, "Hora") && _.get(e, "Capacid") > 0) {
                                this.listaHorasCapacidade.push(_.get(e, "Hora"));
                            }
                        });
                        this.horaLimite = this.listaHorasCapacidade[0];
                    }
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    validacaoFiltros() {

        if (this.dashboardFiltroTipoAgendamento === null || this.dashboardFiltroTipoAgendamento.length === 0)
            return false;
        if (this.dashboardFiltroData === null || this.dashboardFiltroData.length === 0)
            return false;

        return true;
    }

    onChangeDataConsulta = (data) => {
        this.dataConsulta = data;
        this.dashboardFiltroData = this.dataConsulta;
        this.filtraDataCache = false;
    };

    setTipo = (valor) => {
        if (valor) {
            this.tiposPreenchido = valor;
            this.dashboardFiltroTipoAgendamento = valor;
        }
    };

    setDataConsulta = (valor) => {
        this.dashboardFiltroData = valor;
    };

    setFiltroSelecionado(campo, valor) {
        this.filtroSelecionado[campo] = valor;
        lscache.set(`dashboard-${campo}`, valor, 15);
    }

    dataAgendamento = (data) => {
        this.dataAgenda = {
            label: `${moment(data).format("ddd")} - ${moment(data).format("DD/MM/YYYY")}`,
            value: `${moment(data).format("YYYY-MM-DD")}T00:00:00`
        }
        return this.dataAgenda;
    }

    horaAgendamento = (hora) => {
        this.horaAgenda = {
            AgendGold: "N",
            label: {},
            value: hora
        }
        return this.horaAgenda;
    }

    setHoraDashboard = (hora) => {
        this.horaDashboard = hora;
    }

    preparaLinkTipoAgendamento = (agendaId) => {

        if ([1, 46].includes(this.opcaoFainaSelecionada)) {
            this.opcoesTiposAgendamento = {
                pathname: 'agendamento-container/cadastro',
                state: {
                    dados: this.getTipoAgendaIdFromOpcoes(this.tiposAgendaOpcoes, agendaId),
                    voltar: '/agendamento-dashboard',
                    data: this.dataAgendamento(this.dashboardFiltroData),
                    hora: this.horaAgendamento(this.horaDashboard),
                    faina: this.dashboardFiltroTipoAgendamento
                }
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/dashboard/stores/AgendamentoDashboardStore.js